module.exports = __webpack_public_path__ + "img/bg_mobile.15e5873e.png";